module.exports = "/tasks/components/taskHistoryComponent-91a6dc.html";